import React from 'react';

import { StringConstantsMixin } from '../shared/string_constants_mixin';

const ProMixin = {
  removeSpaces(str) {
    return str.replace(/\s/g, '');
  },
  preSubmitErrors() {
    const { errors } = this.state;
    const ccErrors = this.pro_input_fields.preSubmitErrors();
    let signupErrors = [];

    if (this.props.showProSignupElements == true) {
      signupErrors = this.signup_input_fields.preSubmitErrors();
    }
    if (this.state.firstName.trim() == '') {
      errors.first_name = ['Required'];
    }
    if (this.state.lastName.trim() == '') {
      errors.last_name = ['Required'];
    }

    Object.assign(errors, ccErrors);
    this.setState({ errors });

    if (Object.keys(errors).length > 0 || signupErrors.length > 0) {
      return true;
    }
    return false;
  },
  generateCurrency(locale, currency, amount) {
    if (typeof Intl !== 'undefined') {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2
      }).format(amount);
    }
    return `$${amount}`;
  },
  clearStateErrors(errors) {
    if (errors.length > 0 && !_.isEmpty(this.state.errors)) {
      const errorObj = this.state.errors;
      for (let i = 0; i < errors.length; i++) {
        delete errorObj[errors[i]];
      }
      this.setState({ errors: errorObj });
    }
  },
  checkIfRemoveStateErrors() {
    const errorsToRemove = [];
    if (this.state.firstName) errorsToRemove.push('first_name');

    if (this.state.lastName) {
      errorsToRemove.push('last_name');
    }

    this.clearStateErrors(errorsToRemove);
  },
  handleFirstNameTextChange(event) {
    const newVal = event.target.value;
    this.setState({ firstName: newVal }, this.checkIfRemoveStateErrors);
  },
  handleFirstNameTextBlur(event) {
    const newVal = event.target.value;
    this.setState({ firstName: newVal }, this.checkIfRemoveStateErrors);
  },
  handleLastNameTextChange(event) {
    const newVal = event.target.value;
    this.setState({ lastName: newVal }, this.checkIfRemoveStateErrors);
  },
  handleLastNameTextBlur(event) {
    const newVal = event.target.value;
    this.setState({ lastName: newVal }, this.checkIfRemoveStateErrors);
  },
  firstNameDiv() {
    let holderClasses = 'holder';
    let divClasses = 'input string required';
    let errorMessage = '';
    let billingFirstName;
    if (this.props.paramsUser) {
      if (this.props.paramsUser.first_name) {
        billingFirstName = this.props.paramsUser.first_name;
      } else if (this.props.paramsUser.billing_first_name) {
        billingFirstName = this.props.paramsUser.billing_first_name;
      }
    } else if (this.props.user && this.props.user.user) {
      billingFirstName = this.props.user.user.first_name;
    }
    if (Object(this.state.errors).hasOwnProperty('first_name')) {
      divClasses += ' field_with_errors';
      holderClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.state.errors.first_name[0]}</span>;
    }
    return (
      <div className={holderClasses}>
        <div className={divClasses}>
          <input
            className="string required text"
            id="user_first_name"
            maxLength="40"
            name="user[first_name]"
            placeholder={StringConstantsMixin.strings.SIGNUP.FIRST_NAME}
            defaultValue={billingFirstName}
            required="required"
            size="40"
            type="text"
            onChange={this.handleFirstNameTextChange}
            onBlur={this.handleFirstNameTextBlur}
          />
          {errorMessage}
        </div>
      </div>
    );
  },
  lastNameDiv() {
    let holderClasses = 'holder';
    let divClasses = 'input string required';
    let errorMessage = '';
    let billingLastName;
    if (this.props.paramsUser) {
      if (this.props.paramsUser.last_name) {
        billingLastName = this.props.paramsUser.last_name;
      } else if (this.props.paramsUser.billing_last_name) {
        billingLastName = this.props.paramsUser.billing_last_name;
      }
    } else if (this.props.user && this.props.user.user) {
      billingLastName = this.props.user.user.last_name;
    }

    if (Object(this.state.errors).hasOwnProperty('last_name')) {
      divClasses += ' field_with_errors';
      holderClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.state.errors.last_name[0]}</span>;
    }
    return (
      <div className={holderClasses}>
        <div className={divClasses}>
          <input
            className="string required text"
            id="user_last_name"
            maxLength="40"
            name="user[last_name]"
            placeholder={StringConstantsMixin.strings.SIGNUP.LAST_NAME}
            defaultValue={billingLastName}
            required="required"
            size="40"
            type="text"
            onChange={this.handleLastNameTextChange}
            onBlur={this.handleLastNameTextBlur}
          />
          {errorMessage}
        </div>
      </div>
    );
  }
};

export { ProMixin };
